import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';

const CardLine = styled(Flex)`
  background-color: ${toColorString(color.base.fullMoon)};
  padding: 0.625rem 1.188rem;
  height: 2rem;
  gap: 0.213rem;
  align-items: flex-start;
`;

export { CardLine };
